import apiBase from "./api-base";

export default class Account extends apiBase {
    constructor(store) {
        const path = "v1/Auth";
        super(store, path);
  }
  
  login(model, showProgress) {
    return this._request({
        action: "Login",
        method: "POST",
        body: model,
        showProgress,
    });
  }
  ForgotPassword(model, showProgress) {
    return this._request({
        action: "ForgotPassword",
        method: "POST",
        body: model,
        showProgress,
    });
  }
  ResetPassword(model, showProgress) {
    return this._request({
        action: "ResetPassword",
        method: "POST",
        body: model,
        showProgress,
    });
  }
  

}
